import type { Theme } from '@mui/material/styles';

export type MdsThemeVars = NonNullable<Theme['vars']>;

export const themeVars = <TTheme extends Theme>(theme: TTheme): MdsThemeVars | TTheme => theme.vars ?? theme;
